export const BUILD_A_BOX_AVAILABLE_CHOICES_MADE = 'build_a_box_available_choices_made';
export const BUILD_A_BOX_AVAILABLE = 'build_a_box_available';
export const BUILD_A_BOX_UNAVAILABLE = 'build_a_box_unavailable';
export const BUILD_A_BOX_LOCKED_AFTER_CHOICES_MADE = 'build_a_box_locked_after_choices_made';
export const BUILD_A_BOX_LOCKED = 'build_a_box_locked';
export const BUILD_A_BOX_LOCKED_DEFAULT_CHOICES = 'build_a_box_locked_default_choices';



// WEBPACK FOOTER //
// ./src/constants/UpcomingOrderBuildABoxStates.js